import React from 'react'
import { useNavigate } from 'react-router-dom'
import playstoreIcon from '../../Assets/images/playstoreIcon.png'
import './login.css'

const PrivacyPolicyPage = ({ setShowPrivacyPage }) => {
  const navigate = useNavigate()

  return (
    <>
      <div>
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
      </div>

      <div className="container-fluid p-5">
        <div className="text-end mb-2">
          {/* <button
            className="btn btn-light"
            style={{
              border: '1px solid #ccc',
              fontWeight: '500',
            }}
            onClick={() => setShowPrivacyPage(false)}
          >
            Back
          </button> */}

           <button
            className="btn btn-light"
            style={{
              border: '1px solid #ccc',
              fontWeight: '500',
            }}
            onClick={() => navigate(-1)}
          >
            Back
          </button>
        </div>

        <div
          style={{
            background: '#fff',
            borderRadius: '4px',
            padding: '40px',
            minHeight: '600px',
          }}
        >
          <h1
            style={{
              fontSize: '40px',
              fontWeight: '400',
              marginBottom: '35px',
            }}
          >
            Privacy Policy
          </h1>

          <h5 style={{ marginBottom: 30 }}>Last updated: March 11, 2024</h5>

          <p style={{ fontSize: 18 }}>
            This Privacy Policy describes Our policies and procedures on the
            collection, use and disclosure of Your information when You use the
            Service and tells You about Your privacy rights and how the law
            protects You.
          </p>

          <p style={{ fontSize: 18 }}>
            We use Your Personal data to provide and improve the Service. By
            using the Service, You agree to the collection and use of
            information in accordance with this Privacy Policy.
          </p>

          <h2 style={{ marginTop: 45 }}>Interpretation and Definitions</h2>

          <h3>Interpretation</h3>

          <p style={{ fontSize: 18 }}>
            The words of which the initial letter is capitalized have meanings
            defined under the following conditions. The following definitions
            shall have the same meaning regardless of whether they appear in
            singular or in plural.
          </p>

          <h3 style={{ marginTop: 35 }}>Definitions</h3>

          <p style={{ fontSize: 18 }}>
            For the purposes of this Privacy Policy:
          </p>

          <ul style={{ fontSize: 18 }}>
            <li>
              <b>Account</b> means a unique account created for You to access
              our Service or parts of our Service.
            </li>

            <li>
              <b>Company</b> (referred to as either "the Company", "We", "Us" or
              "Our") refers to les digital library.
            </li>

            <li>
              <b>Cookies</b> are small files that are placed on Your computer,
              mobile device or any other device by a website.
            </li>

            <li>
              <b>Country</b> refers to: Maharashtra, India.
            </li>

            <li>
              <b>Device</b> means any device that can access the Service such as
              a computer, cellphone or digital tablet.
            </li>

            <li>
              <b>Personal Data</b> is any information that relates to an
              identified or identifiable individual.
            </li>

            <li>
              <b>Service</b> refers to the Website.
            </li>

            <li>
              <b>Usage Data</b> refers to data collected automatically.
            </li>

            <li>
              <b>Website</b> refers to les digital library,
              https://lesdigitallibrary.in/
            </li>

            <li>
              <b>You</b> means the individual accessing or using the Service.
            </li>
          </ul>

          <h2 style={{ marginTop: 45 }}>
            Collecting and Using Your Personal Data
          </h2>

          <h3>Types of Data Collected</h3>

          <h4>Personal Data</h4>

          <p style={{ fontSize: 18 }}>
            While using Our Service, We may ask You to provide Us with certain
            personally identifiable information that can be used to contact or
            identify You.
          </p>

          <ul style={{ fontSize: 18 }}>
            <li>Email address</li>
            <li>First name and last name</li>
            <li>Phone number</li>
            <li>Usage Data</li>
          </ul>

          <h4 style={{ marginTop: 30 }}>Usage Data</h4>

          <p style={{ fontSize: 18 }}>
            Usage Data is collected automatically when using the Service.
          </p>

          <p style={{ fontSize: 18 }}>
            Usage Data may include information such as Your Device's Internet
            Protocol address (IP address), browser type, browser version, pages
            visited, time and date of Your visit, time spent on those pages,
            unique device identifiers and other diagnostic data.
          </p>

          <p style={{ fontSize: 18 }}>
            When You access the Service through a mobile device, We may collect
            information such as device type, device unique ID, operating system,
            browser type and diagnostic information.
          </p>

          <h3 style={{ marginTop: 35 }}>Cookies</h3>

          <p style={{ fontSize: 18 }}>
            We use Cookies to track the activity on Our Service and store
            certain information.
          </p>

          <p style={{ fontSize: 18 }}>
            Cookies may be Persistent or Session Cookies. Persistent Cookies
            remain on Your device after You go offline, while Session Cookies
            are deleted when You close Your browser.
          </p>

          <h2 style={{ marginTop: 40 }}>Use of Your Personal Data</h2>

          <p style={{ fontSize: 18 }}>
            The Company may use Personal Data for the following purposes:
          </p>

          <ul style={{ fontSize: 18, lineHeight: '34px' }}>
            <li>
              <b>To provide and maintain our Service</b>, including to monitor
              the usage of our Service.
            </li>

            <li>
              <b>To manage Your Account:</b> to manage Your registration as a
              user of the Service. The Personal Data You provide can give You
              access to different functionalities of the Service that are
              available to You as a registered user.
            </li>

            <li>
              <b>For the performance of a contract:</b> the development,
              compliance and undertaking of the purchase contract for the
              products, items or services You have purchased or of any other
              contract with Us through the Service.
            </li>

            <li>
              <b>To contact You:</b> To contact You by email, telephone calls,
              SMS, or other equivalent forms of electronic communication, such
              as a mobile application's push notifications regarding updates or
              informative communications related to the functionalities,
              products or contracted services, including the security updates,
              when necessary or reasonable for their implementation.
            </li>

            <li>
              <b>To provide You</b> with news, special offers and general
              information about other goods, services and events which we offer
              that are similar to those that you have already purchased or
              enquired about unless You have opted not to receive such
              information.
            </li>

            <li>
              <b>To manage Your requests:</b> To attend and manage Your requests
              to Us.
            </li>

            <li>
              <b>For other purposes:</b> We may use Your information for other
              purposes, such as data analysis, identifying usage trends,
              determining the effectiveness of our promotional campaigns and to
              evaluate and improve our Service, products, services, marketing
              and your experience.
            </li>
          </ul>

          <p style={{ fontSize: 18 }}>
            We may share Your personal information in the following situations:
          </p>

          <ul style={{ fontSize: 18, lineHeight: '34px' }}>
            <li>
              <b>With Service Providers:</b> We may share Your personal
              information with Service Providers to monitor and analyze the use
              of our Service, to contact You.
            </li>

            <li>
              <b>With other users:</b> when You share personal information or
              otherwise interact in the public areas with other users, such
              information may be viewed by all users and may be publicly
              distributed outside.
            </li>

            <li>
              <b>With Your consent:</b> We may disclose Your personal
              information for any other purpose with Your consent.
            </li>
          </ul>

          <h2 style={{ marginTop: 40 }}>Retention of Your Personal Data</h2>

          <p style={{ fontSize: 18 }}>
            The Company will retain Your Personal Data only for as long as is
            necessary for the purposes set out in this Privacy Policy. We will
            retain and use Your Personal Data to the extent necessary to comply
            with our legal obligations (for example, if we are required to
            retain your data to comply with applicable laws), resolve disputes,
            and enforce our legal agreements and policies.
          </p>

          <p style={{ fontSize: 18 }}>
            The Company will also retain Usage Data for internal analysis
            purposes. Usage Data is generally retained for a shorter period of
            time, except when this data is used to strengthen the security or to
            improve the functionality of Our Service, or We are legally
            obligated to retain this data for longer time periods.
          </p>

          <h2 style={{ marginTop: 40 }}>Transfer of Your Personal Data</h2>

          <p style={{ fontSize: 18 }}>
            Your information, including Personal Data, is processed at the
            Company's operating offices and in any other places where the
            parties involved in the processing are located. It means that this
            information may be transferred to — and maintained on — computers
            located outside of Your state, province, country or other
            governmental jurisdiction where the data protection laws may differ
            than those from Your jurisdiction.
          </p>

          <p style={{ fontSize: 18 }}>
            Your consent to this Privacy Policy followed by Your submission of
            such information represents Your agreement to that transfer.
          </p>

          <p style={{ fontSize: 18 }}>
            The Company will take all steps reasonably necessary to ensure that
            Your data is treated securely and in accordance with this Privacy
            Policy and no transfer of Your Personal Data will take place to an
            organization or a country unless there are adequate controls in
            place including the security of Your data and other personal
            information.
          </p>

          <h2 style={{ marginTop: 40 }}>Delete Your Personal Data</h2>

          <p style={{ fontSize: 18 }}>
            You have the right to delete or request that We assist in deleting
            the Personal Data that We have collected about You.
          </p>

          <p style={{ fontSize: 18 }}>
            Our Service may give You the ability to delete certain information
            about You from within the Service.
          </p>

          <p style={{ fontSize: 18 }}>
            You may update, amend, or delete Your information at any time by
            signing in to Your Account, if you have one, and visiting the
            account settings section that allows you to manage Your personal
            information. You may also contact Us to request access to, correct,
            or delete any personal information that You have provided to Us.
          </p>

          <h2 style={{ marginTop: 40 }}>Security of Your Personal Data</h2>

          <p style={{ fontSize: 18 }}>
            The security of Your Personal Data is important to Us, but remember
            that no method of transmission over the Internet, or method of
            electronic storage is 100% secure. While We strive to use
            commercially acceptable means to protect Your Personal Data, We
            cannot guarantee its absolute security.
          </p>

          <h2 style={{ marginTop: 40 }}>Children's Privacy</h2>

          <p style={{ fontSize: 18 }}>
            Our Service does not address anyone under the age of 13. We do not
            knowingly collect personally identifiable information from anyone
            under the age of 13. If You are a parent or guardian and You are
            aware that Your child has provided Us with Personal Data, please
            contact Us. If We become aware that We have collected Personal Data
            from anyone under the age of 13 without verification of parental
            consent, We take steps to remove that information from Our servers.
          </p>

          <p style={{ fontSize: 18 }}>
            If We need to rely on consent as a legal basis for processing Your
            information and Your country requires consent from a parent, We may
            require Your parent's consent before We collect and use that
            information.
          </p>

          <h2 style={{ marginTop: 40 }}>Changes to this Privacy Policy</h2>

          <p style={{ fontSize: 18 }}>
            We may update Our Privacy Policy from time to time. We will notify
            You of any changes by posting the new Privacy Policy on this page.
          </p>

          <p style={{ fontSize: 18 }}>
            We will let You know via email and/or a prominent notice on Our
            Service, prior to the change becoming effective and update the "Last
            updated" date at the top of this Privacy Policy.
          </p>

          <p style={{ fontSize: 18 }}>
            You are advised to review this Privacy Policy periodically for any
            changes. Changes to this Privacy Policy are effective when they are
            posted on this page.
          </p>

          <h2 style={{ marginTop: 40 }}>Contact Us</h2>

          <p style={{ fontSize: 18 }}>
            If you have any questions about this Privacy Policy, You can contact
            us:
          </p>

          <ul style={{ fontSize: 18, lineHeight: '34px' }}>
            <li>
              <strong>By email:</strong> gkgcollege1950@gmail.com
            </li>

            <li>
              <strong>By number:</strong> (0231) 2642540
            </li>
          </ul>
        </div>
      </div>

      <div className="footer">
        <div className="col-6 fc1">
          © LES Digital Library 2022 | Managed by:
          <a href="https://technoaarv.com/" target="_blank" rel="noreferrer">
            {' '}
            TechnoAarv Solution
          </a>
        </div>

        <div className="col-6 fc2">
          <a
            // href="https://play.google.com/store/apps/details?id=com.digitallibrarysystem&hl=en"
            href='https://play.google.com/store/apps/details?id=com.les.digitallibrary&pcampaignid=web_share'
            target="_blank"
            rel="noreferrer"
          >
            <img src={playstoreIcon} alt="" />

          
          </a>
        </div>
      </div>
    </>
  )
}

export default PrivacyPolicyPage
